import React from 'react';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import { Dropdown } from 'semantic-ui-react';

class Customer extends React.Component {

  state = {
    customerOption: []
  }

  componentDidMount() {
    this.getCustomerType();
  }

  getCustomerType() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Customer type'
    })
    $.ajax({
      type: 'POST',
      url: Server() + 'customer/getallcustomer.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          context.setAllCustomerType(data);
        } catch (e) {
          console.log(e);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  setAllCustomerType(data) {
    let context = this;
    var customer = [];
    data.map((y) => {
      let text = y.id+"-->"+y.name+"->"+y.mobile+"->"+y.alt_mobile+"->"+y.taluk;
      customer.push({key: text, text: text, value: y.id});
    });
    this.setState({
      customerOption: customer,
      customers: data
    });
    this.getBranchs();
  }

  customer = (f, { value }) => {
    this.setState({ customer: value });
    this.props.update(value, this.state.customers);
  }
  render() {
    return (
      <div>
        <Dropdown placeholder='Customer' style={{ borderColor: '#5A9CBB' }}
         fluid search selection onChange={this.customer}
         options={this.state.customerOption} value={this.state.customer} />
      </div>
    );
  }
}

export default Customer;
